import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { GalleryWrapper } from 'entities/kyrgyzstan/ui/gallery-wrapper'

import type { RealtyObject } from 'shared/api/kyrgyzstan/search'

interface OrderGalleryLocationState {
  realty?: RealtyObject
}

const KyrgyzstanOrderDetailGalleryPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { orderId } = useParams<{ orderId: string }>()

  const realtyData =
    (location.state as OrderGalleryLocationState)?.realty ?? null

  const handleImageClick = (index: number) => {
    if (orderId && realtyData) {
      navigate(
        RoutingPaths.kyrgyzstan.myOrders.galleryImage.path(
          orderId,
          String(index),
        ),
        { state: { realty: realtyData } },
      )
    }
  }

  if (!orderId) {
    return null
  }

  return (
    <GalleryWrapper
      images={realtyData?.images || []}
      title={realtyData?.title || ''}
      isLoading={false}
      error={!realtyData ? t('kyrgyzstan_block.error.title') : null}
      onImageClick={handleImageClick}
    />
  )
}

export default KyrgyzstanOrderDetailGalleryPage
